export default __webpack_public_path__ + "static/media/Regulatory-Compliance-and-Audit-Support.0e3532ee.svg";